import { Address } from '@types'

export const formatAddress = (address?: Address): string => {
  if (!address) return '/'
  const fullAddress =
    (address.street ? address.street + ', ' : '') +
    (address.city ? address.city + ', ' : '') +
    (address.state ? address.state + ', ' : '') +
    (address.zip ? address.zip : '') +
    ((address.secondary?.length || 0) > 0 ? ' #' + address.secondary : '')
  return fullAddress.length > 0 ? fullAddress : '/'
}
